import styled from 'styled-components';

import { typographyV2 } from '../../design-tokens/typography/Typography.styles';

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  scroll-behavior: smooth;
`;

export const ItemWrapper = styled.div<{ $active?: boolean }>`
  display: flex;
  padding: 6px 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  &:hover {
    cursor: pointer;
    background-color: var(--surface-hover);
  }

  a {
    text-decoration: none;
    color: inherit;
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  ${({ $active }) =>
    $active &&
    `color: var(--text-primary);
     border-left: 2px solid var(--border-primary);
 `}
`;

export const Item = styled.p<{ $active?: boolean }>`
  color: var(--text-default);
  ${typographyV2.bodySm}

  ${({ $active }) => $active && `color: var(--text-primary)`}
`;
